import { render, staticRenderFns } from "./workshop-address-info.vue?vue&type=template&id=5409ca52&"
import script from "./workshop-address-info.vue?vue&type=script&lang=js&"
export * from "./workshop-address-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports